export type RecursiveStructure<T = unknown> = T & {
  children?: RecursiveStructure<T>[];
};

export function traverseItems<T>(
  items: RecursiveStructure<T>[],
  callback: (params: {
    item: RecursiveStructure<T>;
    parent: RecursiveStructure<T> | null;
    depth: number;
    done: () => void;
  }) => void,
  options?: Partial<{
    skipDepthIncrease: (item: RecursiveStructure<T>) => boolean;
  }>,
  depth: number = 0,
  parent: RecursiveStructure<T> | null = null
) {
  let isDone = false;
  const done = () => (isDone = true);

  items.forEach((item) => {
    callback({ item, parent, depth, done });
    if (isDone) return;
    if ("children" in item && item.children) {
      const skipIncrease = Boolean(options?.skipDepthIncrease?.(item));
      traverseItems(
        item.children,
        callback,
        options,
        depth + (skipIncrease ? 0 : 1),
        item
      );
    }
  });
}
